import { defaultLanguage, defaultFilterSgaLanguages } from "./state";

/**
 * Mutación que lista los lenguajes de SGA.
 *
 * @param {*} state.languagesSga - Estado de los lenguajes de SGA.
 * @param languagesSga - Lenguajes de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setLanguagesSga(state, languagesSga) {
    state.languagesSga = languagesSga;
}

/**
 * Mutación que establece la acción a realizar (Crear o actualizar).
 *
 * @param {*} state.action - Estado de la acción.
 * @param action - Acción a realizar (create o edit).
 * @return {void}
 * @author Brandon Torres
 */
export function setActionLanguageSga(state, action) {
    state.action = action;
}

/**
 * Mutación que establece el lenguage por defecto.
 *
 * @param {*} state.language - Estado del lenguaje.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultLanguageSga(state) {
    state.language = defaultLanguage();
}

/**
 * Mutación que establece el filtro de lenguajes de SGA por defecto.
 *
 * @param {*} state.filterLanguagesSga - Estado del filtro de lenguajes de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultFilterSgaLanguages(state) {
    state.filterLanguagesSga = defaultFilterSgaLanguages();
}

/**
 * Mutación que establece la cantidad de lenguajes por página.
 *
 * @param {*} state.filterLanguagesSga.per_page - Cantidad de registros por página.
 * @param {*} state.filterLanguagesSga.page - Página actual.
 * @param per_page - Cambio de cantidad de registros por página.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangeSizePagination(state, per_page) {
    state.filterLanguagesSga = {
        ...state.filterLanguagesSga,
        page: 1,
        per_page: per_page,
    };
}

/**
 * Mutación que establece la página actual.
 *
 * @param {*} state.filterLanguagesSga.page - Página actual.
 * @param page - Cambio de página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangePagePagination(state, page) {
    state.filterLanguagesSga.page = page;
}

/**
 * Mutación que establece el paginador de registros de lenguajes.
 *
 * @param {*} state.filterLanguagesSga.page - Página actual.
 * @param {*} state.filterLanguagesSga.per_page - Cantidad de registros por página.
 * @param {*} state.filterLanguagesSga.total - Total de registros.
 * @param paginate - Paginación de registros.
 * @return {void}
 * @author Brandon Torres
 */
export function setPaginateLanguagesSga(state, paginate) {
    state.filterLanguagesSga = {
        ...state.filterLanguagesSga,
        page: paginate.current_page,
        per_page: paginate.per_page,
        total: paginate.total,
    };
}

/**
 * Mutación que establece el lenguaje de SGA.
 *
 * @param {*} state.language - Estado del lenguaje.
 * @param language - Lenguaje de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setLanguageSga(state, language) {
    state.language = {
        id: language.id,
        code: language.code,
        name: language.name,
    };
}

/**
 * Mutación que establece los lenguajes activos de SGA.
 *
 * @param {*} state.activeLanguages - Estado de lenguajes activos de SGA.
 * @param activeLanguages - Lenguajes activos de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setActiveLanguagesSga(state, activeLanguages) {
    state.activeLanguages = activeLanguages;
}

/**
 * Mutación que establece los lenguajes válidos para la API.
 *
 * @param {*} state.languagesValidForApi - Estado de lenguajes válidos para la API.
 * @param languagesValidForApi - Lenguajes válidos para la API.
 * @return {void}
 * @author Brandon Torres
 */
export function setLanguagesValidForApi(state, languagesValidForApi) {
    state.languagesValidForApi = languagesValidForApi;
}
